import { render, staticRenderFns } from "./SortDefinitionNested.vue?vue&type=template&id=3ef751c6&scoped=true"
import script from "./SortDefinitionNested.vue?vue&type=script&lang=js"
export * from "./SortDefinitionNested.vue?vue&type=script&lang=js"
import style0 from "./SortDefinitionNested.vue?vue&type=style&index=0&id=3ef751c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef751c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ef751c6')) {
      api.createRecord('3ef751c6', component.options)
    } else {
      api.reload('3ef751c6', component.options)
    }
    module.hot.accept("./SortDefinitionNested.vue?vue&type=template&id=3ef751c6&scoped=true", function () {
      api.rerender('3ef751c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalogs/SortDefinitionNested.vue"
export default component.exports